import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2,16V4c0-1.1,0.9-2,2-2h11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5,14H4c-1.1,0-2,0.9-2,2s0.9,2,2,2h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22,18H11c-1.1,0-2,0.9-2,2l0,0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11,6h11v16H11c-1.1,0-2-0.9-2-2V8C9,6.9,9.9,6,11,6z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "BookCopy";
const BookCopy = memo(themed(Icon));
export {
  BookCopy
};
//# sourceMappingURL=book-copy.js.map
